export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8974.9a00f0ce.jpg";